import React from "react";
import PropTypes from "prop-types";

// Components
import GlobalLayout from "./global-layout";
import Header from "../header/header";
import AlertStripe from "../alert-stripe/alert-stripe";
import BellyBand from "../belly-band/belly-band";
import Footer from "../footer/footer";

const Home = ({ children }) => {
  return (
    <GlobalLayout>
      {/* "Back to top" link in the footer needs this ID at the beginning of the page. */}
      <div id="main-content"></div>
      <Header />
      <AlertStripe />
      <BellyBand />
      <main>{children}</main>
      <Footer />
    </GlobalLayout>
  );
};

Home.propTypes = {
  children: PropTypes.node.isRequired
};

export default Home;
